import React, { FC, useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './Settings.scss';
import { useQuery } from '@apollo/client/react';
import { GET_SETTING_BY_NAME } from '../../graphql/client/queries';
import { GetSettingByName, GetSettingByNameVariables } from '../../types/schemaTypes';
import { Loading } from '../_common';

const Settings: FC = (): React.ReactElement => {
    const { loading: browserLoading, data: browserData } = useQuery<GetSettingByName, GetSettingByNameVariables>(GET_SETTING_BY_NAME, {
        variables: {
            name: 'BrowserTimeout',
        },
    });

    const { loading: tcLoading, data: tcData } = useQuery<GetSettingByName, GetSettingByNameVariables>(GET_SETTING_BY_NAME, {
        variables: {
            name: 'T&C',
        },
    });

    const [editorContent, setEditorContent] = useState('');

    useEffect(() => {
        if (tcData && tcData.getSettingByName && !tcLoading) {
            if (tcData && tcData.getSettingByName) {
                const raw = tcData.getSettingByName.value || '';
                setEditorContent(DOMPurify.sanitize(raw, { ALLOWED_TAGS: ['p', 'b', 'i', 'u', 'strong', 'em', 'br', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'span'], ALLOWED_ATTR: ['href', 'target', 'rel'] }));
            }
        }
    }, [tcData, tcLoading]);

    const [browserTimeout, setBrowserTimeout] = useState('');
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    useEffect(() => {
        if (browserData && browserData.getSettingByName && !browserLoading) {
            if (browserData && browserData.getSettingByName) {
                setBrowserTimeout(browserData.getSettingByName.value ?? '');
            }
        }
    }, [browserData, browserLoading]);

    const onEditorChange = (content: string) => {
        setEditorContent(content);
    };

    if (browserLoading || tcLoading) {
        return <Loading />;
    }
    document.title = 'Settings';
    return (
        <div className="Settings-Container">
            <div className="Settings-BodyContainer">
                <div id="SettingsContainer" className="Settings-FiltersContainer mt-2">
                    <div className="Filter-Container">
                        <div className="accordion">
                            <div className="FilterItem-Card card">
                                <div className="CustomToggle-Container">
                                    <div className="CustomToggle-Header">
                                        <p className="CustomToggle-Title">Settings</p>
                                        <i className="material-icons CustomToggle-Arrow">keyboard_arrow_down</i>
                                    </div>
                                </div>
                                <div className="collapse show">
                                    <div className="FilterItem-Body FilterItem-BodyPadding card-body pt-4">
                                        <label>Browser Timeout </label>
                                        <div className="SearchBar-Container">
                                            <input
                                                disabled
                                                type="text"
                                                // placeholder="MySandbox Default Logout Time"
                                                className="SearchBar-Input"
                                                value={browserTimeout}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="SettingsEditContainer" className="SettingsEdit-Container">
                    <div className="Settings-Content">
                        <div className="Settings-Header">
                            <div className="row ml-2">
                                <div className="col-sm-12 my-auto pl-0">
                                    <div className="title">Terms Of Use</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 pl-0">
                                <div className="Settings-Container">
                                    <ReactQuill
                                        value={editorContent}
                                        onChange={onEditorChange}
                                        readOnly={true}
                                        modules={{
                                            toolbar: false,
                                        }}
                                        theme="snow"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;

